import { useState } from "react";
import { Box } from "@mui/material";
import oneImg from "../../assets/b1.jpg";
import twoImg from "../../assets/b2.jpg";
import threeImg from "../../assets/b3.jpg";
import fourthImg from "../../assets/b4.jpg";
import fiveImg from "../../assets/b5.jpg";
import sixImg from "../../assets/v1.jpg";
import sevenImg from "../../assets/v12.jpg";
import eightImg from "../../assets/v123.jpg";
import GalleryModal from "./GalleryModal";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

const Gallery = () => {
  const { t } = useTranslation();
  const [openGallery, setOpenGallery] = useState(false);
  const [gallerySrc, setSrcGallery] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const galleryImages = [
    { id: 1, src: oneImg },
    { id: 2, src: twoImg },
    { id: 3, src: threeImg },
    { id: 4, src: fourthImg },
    { id: 5, src: fiveImg },
    { id: 6, src: sixImg },
    { id: 7, src: sevenImg },
    { id: 8, src: eightImg },
  ];

  return (
    <Box>
      {openGallery && (
        <GalleryModal
          openGallery={openGallery}
          setOpenGallery={setOpenGallery}
          imgSrc={gallerySrc}
        />
      )}
      <Box
        sx={{
          paddingX: isMobile ? 4 : 24,
          paddingY: isMobile ? 3 : 6,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #eee",
        }}
      >
        <h1
          style={{
            fontSize: "28px",
            color: "#333",
            letterSpacing: "1px",
            textTransform: "uppercase",
            fontWeight: "600",
            margin: 0,
          }}
        >
          {t("menu.gallery")}
        </h1>
      </Box>

      <Box
        className="content"
        sx={{
          paddingX: isMobile ? 4 : 24,
          paddingY: isMobile ? 3 : 6,
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: isMobile ? "column" : "row",
          flexWrap: "wrap",
        }}
      >
        {galleryImages.map((item) => {
          return (
            <img
              key={item.id}
              src={item.src}
              onClick={() => {
                setOpenGallery(true);
                setSrcGallery(item.src);
              }}
              alt="hawking"
              style={{
                width: isMobile ? "100%" : "22%",
                height: "200px",
                margin: 5,
                cursor: "pointer",
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
};

export default Gallery;
